import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

const TEXT = {
  trial: ["Prolonger l'essai", "Nombre de jours ajoutés à l'essai gratuit.", "Prolonger"],
  gift: ["Offrir des licences", "Nombre total de licences offertes (0 pour retirer). Elles s'ajoutent aux licences payées.", "Enregistrer"],
  suspend: ["", "", ""],
};

export const OrgActionDialog = ({ action, onClose, onDone }) => {
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);
  const kind = action?.kind;
  const org = action?.org;

  useEffect(() => {
    if (kind === "trial") setValue("14");
    if (kind === "gift") setValue(String(org?.seats_gift || 1));
  }, [kind, org]);

  const suspendTitle = org?.suspended ? "Réactiver ce client ?" : "Suspendre ce client ?";
  const suspendDesc = org?.suspended
    ? "Ses techniciens pourront de nouveau se connecter et ses postes se reconnecteront."
    : "Ses techniciens ne pourront plus se connecter et toutes ses sessions en cours seront coupées.";
  const [title, desc, cta] = kind === "suspend" ? [suspendTitle, suspendDesc, org?.suspended ? "Réactiver" : "Suspendre"] : TEXT[kind] || [];

  const submit = async () => {
    const n = Number(value);
    if (kind === "trial" && !(Number.isInteger(n) && n >= 1 && n <= 365)) return toast.error("Indiquez un nombre de jours entre 1 et 365.");
    if (kind === "gift" && !(Number.isInteger(n) && n >= 0 && n <= 500)) return toast.error("Indiquez un nombre de licences entre 0 et 500.");
    setBusy(true);
    try {
      const body = kind === "suspend" ? { suspended: !org.suspended } : kind === "trial" ? { days: Number(value) } : { seats: Number(value) };
      await api.post(`/superadmin/orgs/${org.org_id}/${kind}`, body);
      toast.success("Modification enregistrée");
      onDone();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!action} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="sa-action-dialog">
        <DialogHeader>
          <DialogTitle>{title}{org ? ` — ${org.name}` : ""}</DialogTitle>
          <DialogDescription>{desc}</DialogDescription>
        </DialogHeader>
        {kind !== "suspend" && (
          <Input type="number" min={kind === "gift" ? 0 : 1} value={value} onChange={(e) => setValue(e.target.value)} data-testid="sa-action-input" />
        )}
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="sa-action-cancel">Annuler</Button>
          <Button onClick={submit} disabled={busy} variant={kind === "suspend" && !org?.suspended ? "destructive" : "default"} data-testid="sa-action-confirm">
            {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}{cta}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
